import theme from 'assets/theme/theme';

const styles = () => ({
    root: {
        width: '100%',
        height: '100%',
        overflow: 'auto'
    },
    header: {
        display: 'flex',
        margin: '10px 10px 5px 10px'
    },
    paper: {
        width: 'calc(100% - 20px)',
        overflowX: 'auto',
        marginLeft: '10px',
        height: 'calc(100% - 70px)'
    },
    table: {
        minWidth: 650,
    },
    firstCellContent: {
        display: 'flex',
        alignItems: 'center'
    },
    basicCell: {
        paddingRight: '5px',
        paddingLeft: '5px'
    },
    searchIcon: {
        color: theme.palette.common.grey
    },
    searchBar: {
        width: 'calc(100% - 20px)',
        margin: '0px 0px 0px 5px'
    },
    tableHeadCell: {
        backgroundColor: theme.palette.white.main,
        paddingRight: '5px',
        paddingLeft: '5px'
    },
    leftIcon: {
        marginRight: '4px',
        fontSize: 20
    },
    loaderContainer: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
});

export default styles;
